import { AxiosInstance } from 'axios';
import { IBuildInfo } from 'interfaces/buildInfo/IBuildInfo';
import { Result } from 'services/Result';

export class BuildInfoService {
  axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getBuildInfo = async (): Promise<IBuildInfo> => {
    const response = await this.axiosInstance.get<Result<IBuildInfo>>('build-info');
    const { isError, data } = response.data;
    if (isError || !data?.buildNumber) {
      throw new Error('Build info response is an error or does not contain a build number');
    }

    return data;
  };
}
